/* unplugin-vue-components disabled */import { useField } from "vee-validate";
export default {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    inputmode: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", 'blurEven'],
  setup(props, {
    emit
  }) {
    const name = toRef(props, "name");
    const {
      errorMessage,
      handleChange
    } = useField(name, undefined, {
      initialValue: props.modelValue
    });
    const value = computed({
      get() {
        return props.modelValue;
      },
      set(val) {
        handleChange(val);
        emit("update:modelValue", val);
      }
    });
    const isShowPassword = ref(false);
    return {
      value,
      isShowPassword,
      errorMessage
    };
  }
};